import logo from "../assets/images/logo_white.png";

const TelemedicinePage = ({ children }: { children: React.ReactNode }) => {

  return (
    <div className="telemedicine">
      <div className="logo">
        <img src={logo} alt="logo" />
      </div>
      <div className="containerBox" >
        <div className="survey-wrapper-box">
          <div className="col-md-12">
            {children}
          </div>
        </div>
      </div >
    </div>
  )
}

export default TelemedicinePage
